/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

/**
 * @module
 * @description
 * Entry point for all public APIs of Angular Flex-Layout.
 */
export * from './version';

export * from '@angular/flex-layout/core';
export * from '@angular/flex-layout/extended';
export * from '@angular/flex-layout/flex';
export * from '@angular/flex-layout/grid';

// Flex-Layout Module
export * from './module';
